export type ShareIdQuery = {
    isPresent: boolean
    value: string
}

export function parseShareIdQuery(search: string, paramName: string): ShareIdQuery {
    const params = new URLSearchParams(
        search.startsWith('?') ? search.slice(1) : search,
    )
    if (!params.has(paramName)) {
        return { isPresent: false, value: '' }
    }
    return { isPresent: true, value: params.get(paramName) ?? '' }
}

export function getResolvedShareId(query: ShareIdQuery): string | null {
    if (!query.isPresent) {
        return null
    }
    const trimmed = query.value.trim()
    return trimmed.length > 0 ? trimmed : null
}
